import { createSelector } from 'reselect';

const filterAttribute = state => state.admin.filterAttribute;
const filterOperator = state => state.admin.filterOperator;
const filterValue = state => state.admin.filterValue;

export const getFilterAttribute = createSelector(
  filterAttribute, attribute => attribute
);

export const getFilterOperator = createSelector(
  filterOperator, operator => operator
);

export const getFilterValue = createSelector(
  filterValue, value => value
);
